import { render, staticRenderFns } from "./BotaoPessoa.vue?vue&type=template&id=e58ebcf6&lang=pug"
import script from "./BotaoPessoa.vue?vue&type=script&lang=js"
export * from "./BotaoPessoa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports